import { render } from "./privacy.vue?vue&type=template&id=e9efa60c&scoped=true"
import script from "./privacy.vue?vue&type=script&lang=js"
export * from "./privacy.vue?vue&type=script&lang=js"

import "./privacy.vue?vue&type=style&index=0&id=e9efa60c&rel=stylesheet%2Fscss&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-e9efa60c"
/* hot reload */
if (module.hot) {
  script.__hmrId = "e9efa60c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e9efa60c', script)) {
    api.reload('e9efa60c', script)
  }
  
  module.hot.accept("./privacy.vue?vue&type=template&id=e9efa60c&scoped=true", () => {
    api.rerender('e9efa60c', render)
  })

}

script.__file = "src/views/static/privacy/privacy.vue"

export default script